// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1HI2l","selected":"styles_selected__2mKDj"};